import styled from 'styled-components';

export const Container = styled.div`
  header {
    background-color: #f8f8f8;
    padding: 20px 40px 40px;
    display: flex;
    align-items: center;

    .menu {
      align-items: center;
      display: flex;
      list-style: none;
      margin: 0 0 0 auto;
      padding: 0;

      li {
        margin-left: 30px;

        a {
          color: #4c4c4c;
          font-size: 16px;
          font-weight: bold;
          letter-spacing: 1px;
          opacity: 0.6;
          transition: .3s all;

          &:hover {
            text-decoration: none;
            opacity: 1;
          }

          &.login {
            background-color: #fff;
            border-radius: 6px;
            box-shadow: 0 0 10px 0px rgba(0, 0, 0, 0.15);
            display: block;
            padding: 10px 20px;
          }
        }
      }
    }
  }
  .wrapper {
    max-width: 1140px;
    margin: 0 auto;
    display: flex;
    padding: 0 30px;
  }
  .section-main {
    background-color: #f8f8f8;

    .wrapper {
      .image {
        flex: 1;

        img {
          width: auto;
          max-width: 100%;
        }
      }
      .text {
        flex: 1;

        h1 {
          font-size: 80px;
          font-weight: bold;
          line-height: 85px;
          max-width: 450px;
        }
        p {
          color: #888888;
          font-size: 19px;
          margin: 20px 0 25px;
        }
        a {
          background-color: #37cfa9;
          border-radius: 40px;
          color: #fff;
          display: inline-block;
          font-size: 18px;
          padding: 17px 50px;
          transition: .3s all;

          &:hover {
            opacity: 0.8;
            text-decoration: none;
          }
        }
      }
    }
  }
  .section-promoter {
    background-color: #fff;

    .wrapper {
      padding-top: 50px;

      .text {
        margin-top: 105px;
        max-width: 600px;

        h2 {
          font-size: 40px;
          font-weight: bold;
          margin-bottom: 20px;
        }
        h3 {
          font-weight: normal;
          font-size: 22px;
          margin-bottom: 25px;
          color: #5a5a5a;
        }
        p {
          font-size: 17px;
          margin-bottom: 35px;
        }
        .downloads {
          a {
            margin-right: 20px;

            &:last-child {
              margin-right: 0;
            }
          }
        }
      }
      .image {
        margin-left: auto;

        img {
          max-width: 100%;
        }
      }
    }
  }
  .section-how {
    background-color: #f8f8f8;

    .wrapper {
      padding: 80px 30px 100px;
      display: block;

      h1 {
        text-align: center;
        font-size: 50px;
        font-weight: bold;
        margin-bottom: 40px;
      }
      .process {
        display: grid;
        grid-template-columns: 31% 31% 31%;
        justify-content: space-between;

        .item {
          background-color: #fff;
          border-radius: 10px;
          box-shadow: 0px 0px 7px 4px rgba(0, 0, 0, 0.07);
          text-align: center;
          padding: 15px 40px 20px;

          img {
            display: block;
            margin: 0 auto;
          }
          span {
            font-weight: bold;
            font-size: 20px;
            margin-bottom: 10px;
            display: block;
          }
        }
      }
    }
  }
  footer {
    background-color: #303030;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 30px 0 25px;

    .mail {
      color: #fff;
      font-size: 17px;
      margin-left: -70px;
    }
    .logo-footer {
      margin: 0 40px;
    }
    .social {
      a {
        margin-right: 12px;
      }
    }
  }

  @media (max-width: 1140px) {
    .section-main {
      .wrapper {
        flex-direction: column-reverse;
        text-align: center;

        .text {
          margin: 0 auto 40px;
          max-width: 800px;

          h1 {
            font-size: 70px;
            line-height: 70px;
            max-width: 100%;
          }
        }
      }
    }
    .section-promoter {
      .wrapper {
        flex-direction: column;
        text-align: center;
        padding-top: 30px;

        .text {
          margin: 20px auto 40px;
        }
        .image {
          margin: 0 auto;
        }
      }
    }
    .section-how {
      .wrapper {
        padding: 60px 30px 85px;
      }
    }
  }

  @media (max-width: 900px) {
    .section-how {
      .wrapper {
        padding-bottom: 50px;

        .process {
          row-gap: 30px;
          grid-template-columns: 100%;

          .item {
            p {
              font-size: 17px;
            }
          }
        }
      }
    }
    footer {
      .mail {
        display: none;
      }
      .logo-footer {
        margin-left: 0;
      }
      .social {
        a:last-child {
          margin-right: 0;
        }
      }
    }
  }

  @media (max-width: 480px) {
    header {
      img {
        max-width: 120px;
      }
      .menu {
        li {
          margin-left: 0;

          &:first-child {
            display: none;
          }
        }
      }
    }
    .section-main {
      .wrapper {
        .text {
          h1 {
            font-size: 50px;
            line-height: 50px;
            max-width: 100%;
          }
        }
      }
    }
    .section-promoter {
      .wrapper {
        .text {
          .downloads {
            display: flex;
            flex-direction: column;

            a {
              margin: 0 0 20px;

              &:last-child {
                margin: 0;
              }
            }
          }
        }
      }
    }
  }

  @media (max-width: 360px) {
    footer {
      .social {
        display: none;
      }
      .logo-footer {
        margin-right: 0;
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/Home/styles.js